import React from 'react';
import {
  Modal,
} from 'react-bootstrap';

import AboutCards from './AboutCards';

export default function About({
  show,
  onHide,
}: {
  show: boolean,
  onHide: () => void,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="confirmation-dialog-modal"
    >
      <Modal.Header
        closeButton
        className="confirmation-dialog-modal-header"
      >
        <Modal.Title className="ms-4">
          INSTRUÇÕES
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <AboutCards />
      </Modal.Body>
    </Modal>
  );
}
